"use strict";

(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.Header = {
    attach: function attach() {
      /**
       * TOP NAVIGATION
       * Make the header sticky on scroll
       */
      fixingHeader();
      $(window).scroll(function () {
        fixingHeader();
      });
      function fixingHeader() {
        var scrollHeight = 1;
        if ($(window).scrollTop() > scrollHeight) {
          $('header').addClass('fixedHeader headerWhite');
        } else if ($('.header').hasClass('active') && $(window).scrollTop() === 0) {
          $('header').removeClass('fixedHeader');
        } else if ($('.header').hasClass('active')) {
          $('header').addClass('headerWhite');
        } else {
          $('header').removeClass('fixedHeader headerWhite');
        }
      }

      /* Menu Working - when there is a second tier available */
      $('.has-sub').click(function () {
        if ($(this).parent('.menu-wrapper').children('.sub-menu-wrapper').children('.sub-menu').css('max-height') === '0px') {
          $(this).parent('.menu-wrapper').children('.sub-menu-wrapper').children('.sub-menu').addClass('active');
          $(this).parent('.menu-wrapper').addClass('active');
        } else {
          $(this).parent('.menu-wrapper').children('.sub-menu-wrapper').children('.sub-menu').removeClass('active');
          $(this).parent('.menu-wrapper').removeClass('active');
        }
      });
      /* TOP SEARCH Click to open section */
      $('.js-search-click').click(function () {
        $('.js-top-search-popup').slideDown();
      });
      $('.js-search-popup-close').click(function () {
        $('.js-top-search-popup').slideUp();
      });

      /* Mobile Language Click */
      $('.languageButton').click(function () {
        var windowsize = $(window).width();
        if (windowsize < 1241) {
          if ($('.languageButtonSection').children('.sub-menu-wrapper').css('display') === 'none') {
            $('.languageButtonSection').children('.sub-menu-wrapper').slideDown();
            $(this).parent('.languageButtonSection').addClass('active');
          } else {
            $('.languageButtonSection').children('.sub-menu-wrapper').slideUp();
            $(this).parent('.languageButtonSection').removeClass('active');
          }
        }
      });

      /**
       * TOP NAVIGATION
       * Add Black header class to the header div
       * if there is a class js-header-content-black in innerHeroSection
       */

      /* On search click - pass the values and redirect users to the new url */
      function setValuesOnSearchSubmitButtonClick(SearchSubmitButtonClass) {
        var searchValue = $('.js-top-search-textbox').val().trim();
        var encodedUrl = encodeURIComponent(searchValue);
        if (encodedUrl !== '') {
          encodedUrl = encodedUrl.replace(/%20/g, '+');
          window.location.href = "".concat(SearchSubmitButtonClass, "?query=").concat(encodedUrl, "&items_per_page=10");
        }
      }
      $('.js-top-search-submit').click(function () {
        var SearchSubmitButtonClass = '/search-results';
        setValuesOnSearchSubmitButtonClick(SearchSubmitButtonClass);
      });
      /* Top header search url for Blog navigation */
      $('.js-top-search-submit-blog').click(function () {
        var SearchSubmitButtonClass = '/blog/search';
        setValuesOnSearchSubmitButtonClick(SearchSubmitButtonClass);
      });
    }
  };
  $('.burger-menu').click(function () {
    $(this).toggleClass('active');
    $('.header').toggleClass('active');
    $('.nav-wrapper').toggleClass('show');
    var scroll_top = $(window).scrollTop();
    var scrollHeight = $('header').get(0).scrollHeight;
    if ($('.header').hasClass('active')) {
      $('header').addClass('headerWhite');
    } else if ($(window).scrollTop() < scrollHeight) {
      $('header').removeClass('headerWhite');
    }
  });
  if ($(window).width() < 1241) {
    $('.nav-wrapper .submenu').slideUp();
    $('.nav-wrapper .menu-list >a').click(function (e) {
      var parent = $(this.parentElement);
      e.preventDefault();
      if (parent.hasClass('active')) {
        parent.removeClass('active');
        parent.children('.submenu').slideUp();
        $('.nav-wrapper .menu-list').children('.submenu').slideUp();
      } else {
        $('.nav-wrapper .menu-list .submenu').slideUp();
        $('.nav-wrapper .menu-list ').removeClass('active');
        parent.addClass('active');
        parent.children('.submenu').slideDown();
      }
    });
  }
})(jQuery, Drupal);